import React from 'react';
import styled from 'styled-components';

import device from '../utils/device';

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};

  color: ${({ theme }) => theme.colors.textLight};
  text-align: center;
  padding: 4rem 1rem;

  font-size: 20px;

  @media ${device.desktop} {
    font-size: 30px;
  }
`;

const Banner = ({ children }) => <Container>{children}</Container>;

export { Banner };
export default Banner;
